webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  "data-v-44b6465e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  "data-v-67c291bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('section', [_c('span', [_vm._v("Generation: " + _vm._s(_vm.generationCount))]), _vm._v(" "), _c('span', [_vm._v("Current Population: " + _vm._s(_vm.populationCount))])]), _vm._v(" "), _c('section', [(_vm.islifePaused) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.start()
      }
    }
  }, [_vm._v("Start")]) : _vm._e(), _vm._v(" "), (_vm.islifeInProgress) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.stop()
      }
    }
  }, [_vm._v("Pause")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.randomize()
      }
    }
  }, [_vm._v("Randomize")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.populationCount === 0
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Reset Universe")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("Interval: " + _vm._s(_vm.interval) + "ms")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    attrs: {
      "type": "range",
      "min": "50",
      "max": "1500",
      "step": "50"
    },
    domProps: {
      "value": (_vm.interval)
    },
    on: {
      "__r": function($event) {
        _vm.interval = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('section', [_c('button', {
    attrs: {
      "disabled": _vm.islifeInProgress
    },
    on: {
      "click": function($event) {
        _vm.stepForward()
      }
    }
  }, [_vm._v("Step Forward")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.islifeInProgress || !_vm.hasHistory
    },
    on: {
      "click": function($event) {
        _vm.stepBackward()
      }
    }
  }, [_vm._v("Step Backward")]), _vm._v(" "), _c('span', [_vm._v("History: from " + _vm._s(_vm.firstGenerationInHistory) + " to " + _vm._s(_vm.generationCount))])]), _vm._v(" "), _c('section', [_c('button', {
    attrs: {
      "disabled": _vm.islifeInProgress
    },
    on: {
      "click": function($event) {
        _vm.saveSnapshot()
      }
    }
  }, [_vm._v("Save Snapshot")]), _vm._v(" "), _c('ul', {
    staticClass: "snapshots"
  }, _vm._l((_vm.snapshots), function(snapshot, index) {
    return _c('li', [_c('button', {
      staticClass: "restore",
      attrs: {
        "disabled": _vm.islifeInProgress,
        "title": 'Restore Snapshot (' + snapshot.created + ')'
      },
      on: {
        "click": function($event) {
          _vm.restoreSnapshot(snapshot)
        }
      }
    }, [_vm._v("\n          Restore (" + _vm._s(snapshot.totalCells) + " cells)\n        ")]), _vm._v(" "), _c('button', {
      staticClass: "delete",
      attrs: {
        "disabled": _vm.islifeInProgress,
        "title": "Delete Snapshot"
      },
      on: {
        "click": function($event) {
          _vm.deleteSnapshot(index)
        }
      }
    }, [_vm._v("\n          x\n        ")])])
  }))]), _vm._v(" "), _c('section', [_c('span', [_vm._v("Add pattern:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPattern),
      expression: "selectedPattern"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPattern = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.patterns), function(pattern) {
    return _c('option', {
      domProps: {
        "value": pattern
      }
    }, [_vm._v("\n        " + _vm._s(pattern.name) + " (" + _vm._s(pattern.cells.length) + ")\n      ")])
  })), _vm._v(" "), (_vm.selectedPattern) ? _c('div', {
    staticClass: "drag-item",
    class: {
      'dragged': _vm.isPatternDragged
    },
    attrs: {
      "draggable": "true"
    },
    on: {
      "dragstart": _vm.dragstart,
      "dragend": _vm.dragend
    }
  }, [_vm._v("\n      Drag Me →\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('control'), _vm._v(" "), _c('field')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "main"
    }
  }, [_c('svg', {
    attrs: {
      "id": "field",
      "width": "100%",
      "height": "100%",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.addCell($event)
      },
      "mousedown": function($event) {
        _vm.mousedown($event)
      },
      "mouseup": function($event) {
        _vm.mouseup($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragover($event)
      },
      "drop": function($event) {
        _vm.drop($event)
      }
    }
  }, [_c('g', {
    staticClass: "svg-viewport",
    attrs: {
      "fill": "none"
    }
  }, [_vm._l((_vm.population), function(cell) {
    return _c('rect', {
      staticClass: "cell",
      attrs: {
        "x": cell.coordinates.x,
        "y": cell.coordinates.y,
        "width": "5",
        "height": "5"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.killCell(cell)
        }
      }
    })
  }), _vm._v(" "), (_vm.isPatternDragged) ? _c('use', {
    attrs: {
      "x": _vm.patternX,
      "y": _vm.patternY,
      "xlink:href": "#pattern"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('defs', [(_vm.isPatternDragged) ? _c('g', {
    attrs: {
      "id": "pattern"
    }
  }, _vm._l((_vm.selectedPattern.coordinates), function(coordinate) {
    return _c('rect', {
      staticClass: "cell",
      attrs: {
        "x": coordinate.x,
        "y": coordinate.y,
        "width": "5",
        "height": "5"
      }
    })
  })) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "zoom-control"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.zoomIn()
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetZoom()
      }
    }
  }, [_vm._v("Reset Zoom & Pan")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.zoomOut()
      }
    }
  }, [_vm._v("-")])])])
},staticRenderFns: []}

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return statuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generationEvents; });
var statuses = {
  RUN: 'RUN',
  PAUSE: 'PAUSE'
};

var generationEvents = {
  BIRTH: 'BIRTH',
  DEATH: 'DEATH',
  MANUAL_BIRTH: 'MANUAL_BIRTH',
  MANUAL_DEATH: 'MANUAL_DEATH'
};

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entities_Cell__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entities_Generation__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__entities_Snapshot__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entities_Pattern__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bus__ = __webpack_require__(25);











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* default */]);

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

var universe = new __WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* default */].Store({
  state: {
    status: __WEBPACK_IMPORTED_MODULE_4__types__["a" /* statuses */].PAUSE,
    loopId: null,
    interval: 500,
    population: {},
    generation: new __WEBPACK_IMPORTED_MODULE_6__entities_Generation__["a" /* default */](0),
    generationCount: 0,
    history: [],
    historySize: 100,
    snapshots: [],
    patterns: __WEBPACK_IMPORTED_MODULE_8__entities_Pattern__["a" /* patterns */],
    selectedPattern: null,
    isPatternDragged: false
  },

  getters: {
    islifeInProgress: function islifeInProgress(state) {
      return state.status === __WEBPACK_IMPORTED_MODULE_4__types__["a" /* statuses */].RUN;
    },
    islifePaused: function islifePaused(state) {
      return state.status === __WEBPACK_IMPORTED_MODULE_4__types__["a" /* statuses */].PAUSE;
    },
    lastGeneration: function lastGeneration(state) {
      return state.history[state.history.length - 1];
    },
    populationCount: function populationCount(state) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.population).length;
    }
  },

  mutations: {
    reset: function reset(state) {
      __WEBPACK_IMPORTED_MODULE_9__bus__["a" /* default */].$emit('reset');
      state.status = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* statuses */].PAUSE;
      state.population = {};
      state.history = [];
      state.generationCount = 0;
      state.generation = new __WEBPACK_IMPORTED_MODULE_6__entities_Generation__["a" /* default */](state.generationCount);
    },
    updateInterval: function updateInterval(state, _ref) {
      var value = _ref.value;

      state.interval = value;
    },
    selectPattern: function selectPattern(state, pattern) {
      state.selectedPattern = pattern;
    },
    patternDragStart: function patternDragStart(state) {
      state.isPatternDragged = true;
    },
    patternDragEnd: function patternDragEnd(state) {
      state.isPatternDragged = false;
    },
    addNewGeneration: function addNewGeneration(state) {
      if (state.history.length >= state.historySize) {
        state.history.shift();
      }
      state.history.push(state.generation);
      state.generationCount += 1;
      state.generation = new __WEBPACK_IMPORTED_MODULE_6__entities_Generation__["a" /* default */](state.generationCount);
    },
    removeLastGeneration: function removeLastGeneration(state) {
      state.generationCount -= 1;
      return state.history.pop();
    },
    addCell: function addCell(state, _ref2) {
      var cell = _ref2.cell,
          x = _ref2.x,
          y = _ref2.y,
          manual = _ref2.manual;

      if (!cell) {
        cell = new __WEBPACK_IMPORTED_MODULE_5__entities_Cell__["a" /* default */](x, y);
      }
      var key = cell.getKey();
      cell = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(cell);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.population, key, cell);
      state.generation.addCell(cell, manual);
    },
    killCell: function killCell(state, payload) {
      var cell = payload.cell,
          manual = payload.manual;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.population, cell.getKey());
      state.generation.killCell(cell, manual);
    },
    saveSnapshot: function saveSnapshot(state) {
      var snapshot = new __WEBPACK_IMPORTED_MODULE_7__entities_Snapshot__["a" /* default */](state.population);
      state.snapshots.push(snapshot);
    },
    deleteSnapshot: function deleteSnapshot(state, _ref3) {
      var index = _ref3.index;

      state.snapshots.splice(index, 1);
    }
  },

  actions: {
    start: function start(_ref4) {
      var state = _ref4.state,
          getters = _ref4.getters,
          dispatch = _ref4.dispatch;

      state.status = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* statuses */].RUN;
      state.loopId = setInterval(function () {
        if (!getters.islifeInProgress) {
          clearInterval(state.loopId);
          return;
        }
        dispatch('stepForward');
      }, state.interval);
    },
    stop: function stop(_ref5) {
      var state = _ref5.state;

      state.status = __WEBPACK_IMPORTED_MODULE_4__types__["a" /* statuses */].PAUSE;
      clearInterval(state.loopId);
    },
    updateInterval: function updateInterval(_ref6, value) {
      var commit = _ref6.commit,
          getters = _ref6.getters,
          state = _ref6.state,
          dispatch = _ref6.dispatch;

      commit({ type: 'updateInterval', value: value });
      if (getters.islifeInProgress) {
        clearInterval(state.loopId);
        dispatch('start');
      }
    },
    stepForward: function stepForward(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;

      commit('addNewGeneration');

      var births = {};
      var deaths = {};
      var traversed = {};

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.population).forEach(function (key) {
        var cell = state.population[key];

        var _cell$neighborsKeys$r = cell.neighborsKeys.reduce(function (acc, neighborKey) {
          var neighbor = state.population[neighborKey];
          if (neighbor) {
            acc.liveNeighbors.push(neighborKey);
          } else {
            acc.deadNeighbors.push(neighborKey);
          }
          return acc;
        }, { liveNeighbors: [], deadNeighbors: [] }),
            liveNeighbors = _cell$neighborsKeys$r.liveNeighbors,
            deadNeighbors = _cell$neighborsKeys$r.deadNeighbors;

        if (liveNeighbors.length !== 2 && liveNeighbors.length !== 3) {
          deaths[key] = cell;
        }

        deadNeighbors.forEach(function (neighborKey) {
          if (traversed[neighborKey]) {
            return;
          }
          traversed[neighborKey] = true;
          var surrounding = __WEBPACK_IMPORTED_MODULE_5__entities_Cell__["a" /* default */].getNeighborsFromKey(neighborKey);
          var aliveSurrouning = surrounding.filter(function (i) {
            return state.population[i];
          });
          if (aliveSurrouning.length === 3) {
            var _Cell$getCoordinatesF = __WEBPACK_IMPORTED_MODULE_5__entities_Cell__["a" /* default */].getCoordinatesFromKey(neighborKey),
                x = _Cell$getCoordinatesF.x,
                y = _Cell$getCoordinatesF.y;

            births[neighborKey] = new __WEBPACK_IMPORTED_MODULE_5__entities_Cell__["a" /* default */](x, y);
          }
        });
      });

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(births).forEach(function (key) {
        return commit({ type: 'addCell', cell: births[key] });
      });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(deaths).forEach(function (key) {
        return commit({ type: 'killCell', cell: deaths[key] });
      });
    },
    stepBackward: function stepBackward(_ref8) {
      var commit = _ref8.commit,
          state = _ref8.state,
          getters = _ref8.getters;

      if (state.history.length === 0) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.generation.diff).forEach(function (key) {
        var _state$generation$dif = state.generation.diff[key],
            cell = _state$generation$dif.cell,
            event = _state$generation$dif.event;

        switch (event) {
          case __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].BIRTH:
            {
              commit({ type: 'killCell', cell: cell });
              break;
            }
          case __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].DEATH:
            {
              commit({ type: 'addCell', cell: cell });
              break;
            }
          case __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].MANUAL_BIRTH:
            {
              commit({ type: 'killCell', manual: true, cell: cell });
              break;
            }
          case __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].MANUAL_DEATH:
            {
              commit({ type: 'addCell', manual: true, cell: cell });
              break;
            }
          default:
            break;
        }
      });
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'generation', getters.lastGeneration);
      commit({ type: 'removeLastGeneration' });
    },
    restoreSnapshot: function restoreSnapshot(_ref9, snapshot) {
      var commit = _ref9.commit;

      commit({ type: 'reset' });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(snapshot.population).forEach(function (key) {
        var cell = snapshot.population[key];
        commit({ type: 'addCell', manual: true, cell: cell });
      });
    },
    addPattern: function addPattern(_ref10, _ref11) {
      var commit = _ref10.commit;
      var pattern = _ref11.pattern,
          x = _ref11.x,
          y = _ref11.y;

      pattern.cells.forEach(function (cell) {
        commit({
          type: 'addCell',
          x: cell.x + x,
          y: cell.y + y,
          manual: true
        });
      });
    },
    randomize: function randomize(_ref12) {
      var commit = _ref12.commit,
          state = _ref12.state,
          dispatch = _ref12.dispatch;

      commit({ type: 'reset' });
      var count = getRandomInt(30, 70);

      for (var i = 0; i < count; i += 1) {
        var pattern = state.patterns[getRandomInt(0, state.patterns.length)];
        var x = getRandomInt(-100, 100);
        var y = getRandomInt(-100, 100);
        dispatch({
          type: 'addPattern',
          pattern: pattern,
          x: x,
          y: y
        });
      }
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (universe);

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(23)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(43);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}));

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Cell = function () {
  function Cell(x, y) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Cell);

    var size = 5;
    this.x = x;
    this.y = y;
    this.coordinates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
      x: this.x * size,
      y: this.y * size
    });
    this.neighborsKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(Cell.getNeighborsFromCoordinates(this.x, this.y));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Cell, [{
    key: 'getKey',
    value: function getKey() {
      return Cell.getKeyFromCoordinates(this.x, this.y);
    }
  }], [{
    key: 'getKeyFromCoordinates',
    value: function getKeyFromCoordinates(x, y) {
      return x + ',' + y;
    }
  }, {
    key: 'getCoordinatesFromKey',
    value: function getCoordinatesFromKey(key) {
      var _key$split$map = key.split(',').map(function (i) {
        return parseInt(i, 10);
      }),
          _key$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_key$split$map, 2),
          x = _key$split$map2[0],
          y = _key$split$map2[1];

      return { x: x, y: y };
    }
  }, {
    key: 'getNeighborsFromCoordinates',
    value: function getNeighborsFromCoordinates(x, y) {
      var neighbors = [];
      for (var i = -1; i <= 1; i += 1) {
        for (var j = -1; j <= 1; j += 1) {
          if (i !== 0 || j !== 0) {
            neighbors.push(Cell.getKeyFromCoordinates(i + x, j + y));
          }
        }
      }
      return neighbors;
    }
  }, {
    key: 'getNeighborsFromKey',
    value: function getNeighborsFromKey(key) {
      var _Cell$getCoordinatesF = Cell.getCoordinatesFromKey(key),
          x = _Cell$getCoordinatesF.x,
          y = _Cell$getCoordinatesF.y;

      return Cell.getNeighborsFromCoordinates(x, y);
    }
  }]);

  return Cell;
}();

/* harmony default export */ __webpack_exports__["a"] = (Cell);

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(26);






var Generation = function () {
  function Generation(count) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Generation);

    this.count = count;
    this.diff = {};
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Generation, [{
    key: 'getEntry',
    value: function getEntry(cell) {
      return this.diff[cell.getKey()];
    }
  }, {
    key: 'addCell',
    value: function addCell(cell, manual) {
      var entry = this.getEntry(cell);
      var key = cell.getKey();
      if (manual && entry && entry.event === __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].MANUAL_DEATH) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(this.diff, key);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(this.diff, key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
        cell: cell,
        event: manual ? __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].MANUAL_BIRTH : __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].BIRTH
      }));
    }
  }, {
    key: 'killCell',
    value: function killCell(cell, manual) {
      var entry = this.getEntry(cell);
      var key = cell.getKey();
      if (manual && entry && entry.event === __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].MANUAL_BIRTH) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(this.diff, key);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(this.diff, key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
        cell: cell,
        event: manual ? __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].MANUAL_DEATH : __WEBPACK_IMPORTED_MODULE_4__types__["b" /* generationEvents */].DEATH
      }));
    }
  }]);

  return Generation;
}();

/* harmony default export */ __webpack_exports__["a"] = (Generation);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return patterns; });




var Pattern = function () {
  function Pattern(name, dots) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Pattern);

    var size = 5;
    this.name = name;
    this.dots = dots;
    this.cells = Pattern.getCellsFromDots(this.dots);
    this.coordinates = this.cells.map(function (_ref) {
      var x = _ref.x,
          y = _ref.y;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
        x: x * size,
        y: y * size
      });
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Pattern, null, [{
    key: 'getCellsFromDots',
    value: function getCellsFromDots(dots) {
      var rows = dots.split('\n');
      var result = [];
      rows.forEach(function (row, i) {
        row.trim().split('').forEach(function (char, j) {
          if (char === '*') {
            result.push({ x: j, y: i });
          }
        });
      });
      return result;
    }
  }]);

  return Pattern;
}();

var patterns = [new Pattern('Aircraft carrier', '\n    .**..\n    .*..*\n    ...**\n    '), new Pattern('Acorn', '\n    ..*.....\n    ....*...\n    .**..***\n    '), new Pattern('A for All', '\n    .....**....\n    ....*..*...\n    ....****...\n    ..*.*..*.*.\n    .*........*\n    .*........*\n    ..*.*..*.*.\n    ....****...\n    ....*..*...\n    .....**....\n    '), new Pattern('Airforce', '\n    ........*......\n    .......*.*.....\n    ........*......\n    ...............\n    ......*****....\n    .....*.....*.**\n    ....*.**...*.**\n    ....*.*..*.*...\n    .**.*...**.*...\n    .**.*.....*....\n    .....*****.....\n    ...............\n    .......*.......\n    ......*.*......\n    .......*.......\n    '), new Pattern('Ants', '\n    .**........**...**...**...**...**...**..\n    ...**.**.....**...**...**...**...**...**\n    ...**...**...**...**...**...**...**...**\n    .**.....**.**...**...**...**...**...**..\n    ......**................................\n    '), new Pattern('Bakery', '\n    .....**....\n    ....*..*...\n    ....*.*....\n    ..**.*...*.\n    .*..*...*.*\n    .*.*...*..*\n    ..*...*.**.\n    .....*.*...\n    ....*..*...\n    .....**....\n    '), new Pattern('Barberpole', '\n    ......**\n    .......*\n    ....*.*.\n    ........\n    ..*.*...\n    .*......\n    .**.....\n    '), new Pattern('Beehive with tail', '\n    ..*...\n    .*.*..\n    .*.*..\n    ..*...\n    ...***\n    .....*\n    '), new Pattern('Blinker ship', '\n    ............*..*...............\n    ...........*...................\n    ...........*...*...............\n    ...**......****................\n    ..****.........................\n    .**.**.........................\n    ..**.....**.***................\n    ........*.....**.......*....***\n    .......**.......*......*....*.*\n    ........*.....**.......*....***\n    ..**.....**.***................\n    .**.**.........................\n    ..****.........................\n    ...**......****................\n    ...........*...*...............\n    ...........*...................\n    ............*..*...............\n    '), new Pattern('Boss', '\n    ......*.....\n    .....*.*....\n    .....*.*....\n    ....**.**...\n    ...*.....*..\n    ..*.*.*.*.*.\n    ..*.*...*.*.\n    .**.*...*.**\n    .*..*.*.*..*\n    ...*.....*..\n    ....**.**...\n    .....*.*....\n    .....*.*....\n    ......*.....\n    '), new Pattern('Brain', '\n    ..**........\n    .*..*.....**\n    .***...***..\n    .*..*.****..\n    ..***...*...\n    ..*..***....\n    ....*....**.\n    ....*****.*.\n    ............\n    ....*****.*.\n    ....*....**.\n    ..*..***....\n    ..***...*...\n    .*..*.****..\n    .***...***..\n    .*..*.....**\n    ..**........\n    '), new Pattern('Caterer', '\n    ......*..\n    .****...*\n    ....*...*\n    ........*\n    .....*...\n    ......**.\n    '), new Pattern('Chemist', '\n    ........*.......\n    ........***.....\n    ...........*....\n    ......***..*..**\n    .....*.*.*.*.*.*\n    .....*...*.*.*..\n    ..**.*.*.*.*.**.\n    ...*.*.*...*....\n    .*.*.*.*.*.*....\n    .**..*..***.....\n    .....*..........\n    ......***.......\n    ........*.......\n    '), new Pattern('Fumarole', '\n    ....**...\n    ..*....*.\n    ..*....*.\n    ..*....*.\n    ...*..*..\n    .*.*..*.*\n    .**....**\n    '), new Pattern('Glider', '\n    ...*\n    .*.*\n    ..**\n    '), new Pattern('Gourmet', '\n    ...........**........\n    ...........*.........\n    ...*.**.**.*.....**..\n    ...**.*.*.*......*...\n    .........*........*..\n    .................**..\n    .....................\n    ............*....**..\n    .*.........*.*..*.*..\n    .***......**.**..*...\n    ....*.............***\n    ...*.*..............*\n    ...**................\n    .....................\n    ...**................\n    ...*........*........\n    ....*......*.*.*.**..\n    ...**.....*.**.**.*..\n    ..........*..........\n    .........**..........\n    '), new Pattern('Hertz oscillator', '\n    ....**.*....\n    ....*.**....\n    ............\n    .....***....\n    ....*.*.*.**\n    ....*...*.**\n    .**.*...*...\n    .**.*...*...\n    .....***....\n    ............\n    .....**.*...\n    .....*.**...\n    '), new Pattern('Hustler', '\n    ......**....\n    ......**....\n    ............\n    ....****....\n    .*.*....*...\n    .**.*...*...\n    ....*...*.**\n    ....*....*.*\n    .....****...\n    ............\n    .....**.....\n    .....**.....\n    '), new Pattern('Induction coil', '\n    ..**....\n    ..*..*..\n    ...***..\n    ........\n    .*******\n    .*..*..*\n    '), new Pattern('Jam', '\n    .....**.\n    ....*..*\n    ..*..*.*\n    .*....*.\n    .*......\n    ...***..\n\n    '), new Pattern('Lightweight emulator', '\n    ...**.*..*.**..\n    ...*........*..\n    ....**....**...\n    .***..****..***\n    .*..*......*..*\n    ..**........**.\n    '), new Pattern('Middleweight volcano', '\n    ....*******...\n    ..***.***.***.\n    .*....***....*\n    ..****.*.***.*\n    ............*.\n    .*.**.*.*.*...\n    .**.*.*.*.**..\n    .....*..*.*...\n    ......**..*...\n    ..........**..\n    '), new Pattern('Pseudo-barberpole', '\n    ...........**\n    ............*\n    ..........*..\n    ........*.*..\n    .............\n    ......*.*....\n    .............\n    ....*.*......\n    .............\n    ...**........\n    .*...........\n    .**..........\n\n    '), new Pattern('R2D2', '\n    ....**...\n    ....**...\n    .........\n    ..******.\n    .*......*\n    .***...**\n    .........\n    .********\n    .*......*\n    ....**...\n    ....**...\n\n    '), new Pattern('Rephaser', '\n    ....**...\n    ....**...\n    .........\n    .........\n    ..**..**.\n    .*.*..*.*\n    ...*..*..\n    '), new Pattern('Revolver', '\n    .**....**\n    ..*....*.\n    ..*.**.*.\n    ...*..*..\n    ....*....\n    ......*..\n    ..**.....\n    ......**.\n    ...*.....\n    .....*...\n    ...*..*..\n    ..*.**.*.\n    ..*....*.\n    .**....**\n    '), new Pattern('Roteightor', '\n    ..*............\n    ..***........**\n    .....*.......*.\n    ....**.....*.*.\n    ...........**..\n    ...............\n    ......***......\n    ......*..*.....\n    ......*........\n    ...**..*...*...\n    ..*.*......*...\n    ..*.......*....\n    .**........***.\n    .............*.\n\n    '), new Pattern('Ship on boat, boat-ship-tie', '\n    .**....\n    .*.*...\n    ..**...\n    ....**.\n    ....*.*\n    .....*.\n    '), new Pattern('Siesta', '\n    ............**...\n    ....**.....*.*...\n    ....*.*....*.....\n    ......*...**.*...\n    ....*.**.....***.\n    ..***.....*.*...*\n    .*...*.*.....***.\n    ..***.....**.*...\n    ....*.**...*.....\n    ......*....*.*...\n    ....*.*.....**...\n    ....**...........\n    '), new Pattern('Sparky', '\n    ...........*....................\n    ...........*...............**...\n    .......**.*.***..........**...*.\n    .*.**.**.**..*.*...**.****......\n    .*...**..*.**..***..*.**..**...*\n    .*.**....***.*.***......**..*...\n    .........**.*...............*..*\n    .*.**....***.*.***......**..*...\n    .*...**..*.**..***..*.**..**...*\n    .*.**.**.**..*.*...**.****......\n    .......**.*.***..........**...*.\n    ...........*...............**...\n    ...........*....................\n    '), new Pattern('Switch engine', '\n    ..*.*..\n    .*.....\n    ..*..*.\n    ....***\n    '), new Pattern('Tubber', '\n    .....*.*......\n    .....**.*.....\n    ........***...\n    .....**....*..\n    .**.*..**..*..\n    ..*.*....*.**.\n    .*...*...*...*\n    ..**.*....*.*.\n    ...*..**..*.**\n    ...*....**....\n    ....***.......\n    ......*.**....\n    .......*.*....\n\n    '), new Pattern('Unix', '\n    ..**.....\n    ..**.....\n    .........\n    ..*......\n    .*.*.....\n    .*..*..**\n    .....*.**\n    ...**....\n    ')];

/* unused harmony default export */ var _unused_webpack_default_export = (Pattern);


/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);




var Snapshot = function Snapshot(population) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Snapshot);

  this.population = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, population);
  this.created = new Date();
  this.totalCells = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.population).length;
};

/* harmony default export */ __webpack_exports__["a"] = (Snapshot);

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Control__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Control__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Field__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Field__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Control: __WEBPACK_IMPORTED_MODULE_0__components_Control___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_1__components_Field___default.a
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'control',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['islifePaused', 'islifeInProgress', 'populationCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    generationCount: function generationCount(state) {
      return state.generationCount;
    },
    hasHistory: function hasHistory(state) {
      return state.history.length !== 0;
    },
    firstGenerationInHistory: function firstGenerationInHistory(state) {
      return state.generationCount - state.history.length;
    },
    snapshots: function snapshots(state) {
      return state.snapshots;
    },
    patterns: function patterns(state) {
      return state.patterns;
    },
    isPatternDragged: function isPatternDragged(state) {
      return state.isPatternDragged;
    }
  }), {
    interval: {
      get: function get() {
        return this.$store.state.interval;
      },
      set: function set(value) {
        this.$store.dispatch('updateInterval', value);
      }
    },
    selectedPattern: {
      get: function get() {
        return this.$store.state.selectedPattern;
      },
      set: function set(pattern) {
        this.$store.commit('selectPattern', pattern);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['reset', 'saveSnapshot', 'deleteSnapshot']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapActions */])(['start', 'stop', 'stepForward', 'stepBackward', 'restoreSnapshot', 'randomize']), {
    dragstart: function dragstart(event) {
      this.$store.commit('patternDragStart');
      var dummyEl = document.createElement('span');
      event.dataTransfer.setDragImage(dummyEl, 0, 0);
    },
    dragend: function dragend() {
      this.$store.commit('patternDragEnd');
    }
  })
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_bus__ = __webpack_require__(25);






var cellSize = 5;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'field',
  data: function data() {
    return {
      patternX: 0,
      patternY: 0
    };
  },
  mounted: function mounted() {
    this.field = svgPanZoom('#field', {
      viewportSelector: '.svg-viewport',
      controlIconsEnabled: false,
      zoomEnabled: true,
      dblClickZoomEnabled: false,
      fit: false,
      center: true,
      minZoom: 0.25,
      maxZoom: 10
    });
    this.mousedownXY = {};
    __WEBPACK_IMPORTED_MODULE_2__store_bus__["a" /* default */].$on('reset', this.resetZoom);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['islifePaused', 'islifeInProgress']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    population: function population(state) {
      return state.population;
    },
    selectedPattern: function selectedPattern(state) {
      return state.selectedPattern;
    },
    isPatternDragged: function isPatternDragged(state) {
      return state.isPatternDragged;
    }
  })),
  methods: {
    mousedown: function mousedown(event) {
      this.preventClick = true;
      this.mousedownXY = {
        x: event.clientX,
        y: event.clientY
      };
    },
    mouseup: function mouseup(event) {
      var clientX = event.clientX,
          clientY = event.clientY;

      var deltaX = Math.abs(clientX - this.mousedownXY.x);
      var deltaY = Math.abs(clientY - this.mousedownXY.y);
      this.preventClick = deltaX > 0 || deltaY > 0;
    },
    dragover: function dragover(event) {
      if (!this.isPatternDragged) {
        return;
      }

      var _getCoordinatesFromEv = this.getCoordinatesFromEvent(event),
          x = _getCoordinatesFromEv.x,
          y = _getCoordinatesFromEv.y;

      this.patternX = x * cellSize;
      this.patternY = y * cellSize;
    },
    drop: function drop(event) {
      if (!this.isPatternDragged) {
        return;
      }

      var _getCoordinatesFromEv2 = this.getCoordinatesFromEvent(event),
          x = _getCoordinatesFromEv2.x,
          y = _getCoordinatesFromEv2.y;

      this.$store.dispatch({ type: 'addPattern', pattern: this.selectedPattern, x: x, y: y });
    },
    zoomIn: function zoomIn() {
      this.field.zoomIn();
    },
    zoomOut: function zoomOut() {
      this.field.zoomOut();
    },
    resetZoom: function resetZoom() {
      this.field.resetZoom();
      this.field.center();
    },
    addCell: function addCell(event) {
      if (this.islifeInProgress || this.preventClick) {
        return;
      }

      var _getCoordinatesFromEv3 = this.getCoordinatesFromEvent(event),
          x = _getCoordinatesFromEv3.x,
          y = _getCoordinatesFromEv3.y;

      this.$store.commit({ type: 'addCell', manual: true, x: x, y: y });
    },
    killCell: function killCell(cell) {
      if (this.islifeInProgress || this.preventClick) {
        return;
      }
      this.$store.commit({ type: 'killCell', manual: true, cell: cell });
    },
    getCoordinatesFromEvent: function getCoordinatesFromEvent(event) {
      var fieldSize = document.getElementById('main').getBoundingClientRect();
      var zoom = this.field.getZoom();
      var pan = this.field.getPan();
      var x = Math.floor((event.clientX - fieldSize.left - pan.x) / (zoom * cellSize));
      var y = Math.floor((event.clientY - fieldSize.top - pan.y) / (zoom * cellSize));
      return { x: x, y: y };
    }
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[45]);


// WEBPACK FOOTER //
// static/js/app.ac5bebd3c4dc2f5a81d1.js